/**
 * BPM Designer Store module
 */
import publication from './publication'

export default {
  namespaced: true,

  state: {},
  getters: {},
  mutations: {},
  actions: {},

  modules: {
    publication
  }
}



// WEBPACK FOOTER //
// ./src/apps/bpm/catalog/store/index.js